import { ExpenseTypeOutputWithStatus } from './expense-type-output-with-status.model';


export class ExpenseTypeSelectByIdOutput implements IExpenseTypeSelectByIdOutput {
    status!: number;
    message!: string;
    data!: ExpenseTypeOutputWithStatus;

    constructor(data?: IExpenseTypeSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? ExpenseTypeOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExpenseTypeSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExpenseTypeSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IExpenseTypeSelectByIdOutput {
    status: number;
    message: string;
    data: ExpenseTypeOutputWithStatus;
}

